import React from 'react';

// An exception loosens the policy for a while: why, who approved it, and when it ends. All three are required by the API, and the end
// date itself still counts. After it the policy is ignored. A kind that is an exception by nature (a CVE exclusion) asks for the three at once:
// `required` leaves out the checkbox.
export default function ExceptionField({ value, onChange, required = false }) {
  const e = value || { on: required, reason: '', approvedBy: '', expires: '' };
  const set = (patch) => onChange({ ...e, ...patch });
  return (
    <div className="exception">
      {!required && (
        <label className="check">
          <input type="checkbox" aria-label="This policy has an exception" checked={!!e.on} onChange={(ev) => set({ on: ev.target.checked })} />
          This policy is an exception
        </label>
      )}
      {(required || e.on) && (
        <div className="exception-fields">
          <input type="text" aria-label="Exception reason" placeholder="why it is needed" value={e.reason} onChange={(ev) => set({ reason: ev.target.value })} />
          <input type="text" aria-label="Approved by" placeholder="who approved it" value={e.approvedBy} onChange={(ev) => set({ approvedBy: ev.target.value })} />
          <input type="date" aria-label="Exception ends" value={e.expires} onChange={(ev) => set({ expires: ev.target.value })} />
        </div>
      )}
    </div>
  );
}
